document.addEventListener('DOMContentLoaded', function () {
  
  let videoIndex = document.querySelector('.custom-swiper-slide')?.getAttribute('data-no');
  videoIndex = parseInt(videoIndex);
  
    window.newPDPimgSwipix = new Swipix({
      container: '.custom-swipix-container-pdp-img',
      nextButton: '.custom-right-arrow-pdp',
      prevButton: '.custom-left-arrow-pdp',
      slidesPerView: { default: 1 },
      lazyMedia: true,
      // gap: 1,
      autoplay: {
        enabled: false,
        delay: 5000,               
        pauseOnInteraction: false,  
        pauseAfterInteraction: false 
      },
      tabsConfig: {
        container: '.custom-swiper-container',
        buttonSelector: '.custom-swiper-slide',
        mapping: [videoIndex, videoIndex+1, videoIndex+2, videoIndex+3, videoIndex+4, videoIndex+5, videoIndex+6, videoIndex+7, videoIndex+8, videoIndex+9, videoIndex+10], 
        activeClass: 'activefeat'
      }
    }).init();
  
    const pdpNumberEle = document.querySelector('.current_slide_count-new');
    const visitedSlides = [1];
  
    document.addEventListener('swipix:slideChanged', (e) => {
      if(e.detail.carousel.config.container == '.custom-swipix-container-pdp-img'){
        const currentSlide = e.detail.currentIndex + 1;
        pdpNumberEle.textContent = currentSlide;
  
        if (!visitedSlides.includes(currentSlide)) {
          // Fire GA event (replace this with your GA event code)
          gaEvent('pdp_img', [currentSlide, '', '', '', '', ''], false);
          
          // Add the current slide index to the visited array
          visitedSlides.push(currentSlide);
        }
      }
    });
  });
  
  const qtyInputs = document.querySelectorAll('.dev_npdp_qty');
  const plusButtons = document.querySelectorAll('.dev_qty_plus');
  const minusButtons = document.querySelectorAll('.dev_qty_minus');

  // Function to update all quantity inputs
  function updateAllQty(newValue) {
    newValue = Math.max(newValue, 1);
    
    qtyInputs.forEach(input => {
      input.value = newValue;
    });
    
    $(document).find('.dev_atc_form').attr('data-quantity', newValue);
  }

  // Add event listeners to all plus buttons
  plusButtons.forEach(button => {
    button.addEventListener('click', () => {
      // Get the current value from the first input (they should all be the same)
      let currentQty = parseInt(qtyInputs[0].value) || 1;
      updateAllQty(currentQty + 1);
    });
  });

  // Add event listeners to all minus buttons
  minusButtons.forEach(button => {
    button.addEventListener('click', () => {
      // Get the current value from the first input (they should all be the same)
      let currentQty = parseInt(qtyInputs[0].value) || 1;
      updateAllQty(currentQty - 1);
    });
  });

  // Add event listeners to all quantity inputs
  qtyInputs.forEach(input => {
    input.addEventListener('input', function(e) {
      let value = parseInt(e.target.value);
      if (isNaN(value) || value < 1) {
        value = 1;
      }
      updateAllQty(value);
    });
  });
  
  document.addEventListener("DOMContentLoaded", () => {
    const startTimer = (duration, displays) => {
      const endTime = Date.now() + duration * 1000;
      const intervalId = setInterval(() => {
        // Calculate the remaining time in seconds
        const remaining = Math.max(0, Math.floor((endTime - Date.now()) / 1000));
        const days = Math.floor(remaining / (24 * 3600));
        const hours = Math.floor((remaining % (24 * 3600)) / 3600);
        let minutes = Math.floor((remaining % 3600) / 60);
        let seconds = remaining % 60;
        
        // Format minutes and seconds
        minutes = minutes < 10 ? "0" + minutes : minutes;
        seconds = seconds < 10 ? "0" + seconds : seconds;
        
        // Prepare the display text
        const displayText = `${days}d ${hours}h ${minutes}m ${seconds}s`;
        
        // Update all display elements
        displays.forEach(display => {
          display.textContent = displayText;
        });
        
        // Clear the interval if the countdown has finished
        if (remaining <= 0) {
          clearInterval(intervalId);
        }
      }, 1000);
    };
  
    // Get the offer end date and calculate the duration in seconds
    const offerEndDate = new Date(window.newPDPTimerDate).getTime();
    const now = Date.now();
    const duration = Math.floor((offerEndDate - now) / 1000);
  
    // Get display elements and convert HTMLCollection to an array
    const displays = Array.from(document.getElementsByClassName("offer-time-new"));
  
    // Start the timer if there is at least one display element and the duration is positive
    if (displays.length > 0 && duration > 0) {
      startTimer(duration, displays);
    }
  });
  
  // Timer end
  $(document).ready(function(){
        
    $(document).find('.dev_show_images_after_slick_load').css({ position: "", top: "", visibility: "" });
    $(document).find('.dev_hide_images_after_slick_load').hide();
  
    $(document).on('click', ".dev_features_icon", function(){
       /* FEATURE ICON GA4 EVENT */
         if (typeof dataLayer !== 'undefined') {
            dataLayer.push({custom:null});
            dataLayer.push({
                event:"feature_highlight",
                custom:
                {
                  param_1:$(this).data('position'),
                  param_2:$(this).data('feature'),
                  param_3:"",
                  param_4:""
                }
            })
          }         
      });
  });
  
  var buyxgetY= false;
    document.addEventListener("DOMContentLoaded", function() {
      var coupn_txt = window.newPdpCouponName;
      var coupn_total_discount_amount = window.newPdpCouponDiscount;
  
      
      // Parse the variant data from the JSON script tag
      const productData = JSON.parse(document.getElementById('product-data').textContent);
      const variants = productData.variants;
      
      function getValidMattressOptions(selectedSize) {
        const validMattressOptions = new Set();
        
        variants.forEach(variant => {
          if (variant.options[0] === selectedSize) {
            validMattressOptions.add(variant.options[1]);
          }
        });
        
        return Array.from(validMattressOptions);
      }
      
      function updateMattressDropdown(selectedSize) {
        const mattressDropdown = document.querySelector('select.dev_npdp_variant_change_selector_element');
        if (!mattressDropdown) return;
        
        const validOptions = getValidMattressOptions(selectedSize);
        
        const currentSelection = mattressDropdown.value;
        
        mattressDropdown.innerHTML = '';
        
        validOptions.forEach(option => {
          const optionElement = document.createElement('option');
          optionElement.value = option;
          optionElement.textContent = option;
          optionElement.setAttribute('data-inchValue', option);
          optionElement.setAttribute('data-centimeterValue', '');
          mattressDropdown.appendChild(optionElement);
        });
        
        if (validOptions.includes(currentSelection)) {
          mattressDropdown.value = currentSelection;
        }
        
        const selectedVariantText = document.getElementById('dev_selected_variant_option2');
        if (selectedVariantText) {
          selectedVariantText.textContent = mattressDropdown.value;
        }
        
        const changeEvent = new Event('change', { bubbles: true });
        mattressDropdown.dispatchEvent(changeEvent);
      }
      
      function getValidFrameOptions(selectedSize, selectedMattress) {
        const validFrameOptions = new Set();
        
        variants.forEach(variant => {
          if (variant.options[0] === selectedSize && variant.options[1] === selectedMattress) {
            if (variant.options.length > 2) {
              validFrameOptions.add(variant.options[2]);
            }
          }
        });
        
        return Array.from(validFrameOptions);
      }
      
      function updateFrameOptions(selectedSize, selectedMattress) {
        const frameLabels = document.querySelectorAll('.npdp-variant-options-name-frame_type___color .npdp-radio-label');
        if (frameLabels.length === 0) return;
        
        const validOptions = getValidFrameOptions(selectedSize, selectedMattress);
        
        frameLabels.forEach(label => {
          const input = label.querySelector('input');
          if (!input) return;
          
          const frameValue = input.getAttribute('data-select_value');
          
          if (validOptions.includes(frameValue)) {
            label.style.display = '';
            if (!document.querySelector('.npdp-variant-options-name-frame_type___color .npdp-radio-label.selected-radio')) {
              label.classList.add('selected-radio');
              input.checked = true;
              
              const dev_selected_variant_option3 = document.getElementById('dev_selected_variant_option3');
              if (dev_selected_variant_option3) {
                dev_selected_variant_option3.textContent = frameValue;
              }
            }
          } else {
            label.style.display = 'none';
            if (label.classList.contains('selected-radio')) {
              label.classList.remove('selected-radio');
              input.checked = false;
            }
          }
        });
      }

      // Initialize variant validation on page load
      const selectedSizeLabel = document.querySelector('.npdp-variant-options-name-size .npdp-radio-label.selected-radio');
      if (selectedSizeLabel) {
        const selectedSizeInput = selectedSizeLabel.querySelector('input');
        if (selectedSizeInput) {
          const selectedSize = selectedSizeInput.getAttribute('data-select_value');
          selectedSizeInput.checked = true;
          console.log("selectedSize ==> ", selectedSize);
          
          // Update mattress options based on initially selected size
          updateMattressDropdown(selectedSize);
          
          // Also update frame options if mattress is selected
          const mattressDropdown = document.querySelector('select.dev_npdp_variant_change_selector_element');
          if (mattressDropdown) {
            updateFrameOptions(selectedSize, mattressDropdown.value);
          }
        }
      }
      
      // Function to find the variant ID based on selected options
      function getSelectedVariantId() {
        // Collect selected options
        let selectedOptions = [];
        
        document.querySelectorAll('.variant-option').forEach(function(optionWrapper) {
          // Check for radio buttons
          const selectedRadio = optionWrapper.querySelector('input[type="radio"]:checked');
          // Check for select dropdowns
          const selectedOption = optionWrapper.querySelector('select.dev_npdp_variant_change_selector_element');
          
          if (selectedRadio) {
            selectedOptions.push(selectedRadio.value);
          } else if (selectedOption) {
            selectedOptions.push(selectedOption.value);
          }
        });
        
        // Find the matching variant ID
        let selectedVariantId = null;
        let selectedVariantPrice = null;
        let selectedVariantCompPrice = null;
        let discount = 0;
        let featureimage = "";
        
        variants.forEach(function(variant) {
          if (JSON.stringify(variant.options) === JSON.stringify(selectedOptions)) {
            selectedVariantId = variant.id;
            selectedVariantPrice = variant.price;
            selectedVariantCompPrice = variant.compare_at_price;
  
            var price_difference = variant.normal_compare_at_price - variant.normal_price;
            var discount_percentage = (price_difference * 100.0) / variant.normal_compare_at_price;
            discount = Math.round(discount_percentage);
            featureimage = variant.featureimage;
          }
        });
        
        return selectedVariantId+"----"+selectedVariantPrice+"----"+selectedVariantCompPrice+"----"+discount+"----"+featureimage;
      }
  
      let v_id_p = getSelectedVariantId();
      v_id_p = v_id_p.split('----');
      getSlideIndexFromImageUrl(v_id_p[4]);
  
      // Update UI function - reused for both radio and select changes
      function updateVariantUI(variantInfo) {
        const v_id_p = variantInfo.split('----');
        
        getSlideIndexFromImageUrl(v_id_p[4]);
        $(document).find('.dev_variant_id').val(""+v_id_p[0]+"");
        $(document).find('.dev_variant_price').text(""+v_id_p[1]+"");
        $(document).find('.dev_update-price-onvariantchange').text(""+v_id_p[1]+"");
        //$(document).find('.dev_edithtml_discount_strip .chair-price').text("₹"+formatToIndianNumberingSystem(parseFloat(v_id_p[1].replace(/[^0-9.-]+/g, '')) - coupn_total_discount_amount));
        //$(document).find('.dev_edithtml_discount_strip .chair-coupen').text(coupn_txt);
        $(document).find('.dev_variant_comp_price').text(""+v_id_p[2]+"");
        $(document).find('.dev_update-compareatprice-onvariantchange span').text(""+v_id_p[2]+"");
        $(document).find('.dev_discount_per').text(v_id_p[3]+"% off ");
        $(document).find('.dev_update-discount-onvariantchange').text(v_id_p[3]+"% off ");
        product_data['variant_id'] = v_id_p[0];
        $(document).find('.dev_edd_variant_id').val(v_id_p[0]);
        $(document).find('.dev_atc_form').attr('data-variant-id', v_id_p[0]);
        
        runBundleScript(v_id_p[0]);
        
        setTimeout(function(){
            if ($('.dev_edd_content').is(':visible')) {
              if($(document).find('.dev_pincode').val() != "")
                  $(document).find('.dev_npdp_checkpincode').trigger("click");  
            }
          }, 1000);
        updateURL(v_id_p[0]);
      }
  
      // Attach change event listeners to radio buttons
      document.querySelectorAll('.dev_npdp_variant_change').forEach(function(radio) {
        radio.addEventListener('change', function() {
          let v_id_p = getSelectedVariantId();
          updateVariantUI(v_id_p);
        });
      });
      
      // Attach change event listeners to select dropdowns
      document.querySelectorAll('.dev_npdp_variant_change_selector_element').forEach(function(select) {
        select.addEventListener('change', function() {
          // Find the parent variant option element and update the selected variant text
          const parentElement = select.closest('.dev_parent_to_change_variant_name');
          if (parentElement && parentElement.querySelector('.v2_selected_variant')) {
            parentElement.querySelector('.v2_selected_variant').textContent = select.value;
          }
          
          const selectedSize = document.querySelector('.npdp-variant-options-name-size .npdp-radio-label.selected-radio input')?.getAttribute('data-select_value');
          if (selectedSize) {
            updateFrameOptions(selectedSize, select.value);
          }
          
          let v_id_p = getSelectedVariantId();
          updateVariantUI(v_id_p);

          const dev_selected_variant_option2 = document.getElementById('dev_selected_variant_option2');
          if (dev_selected_variant_option2) {
              dev_selected_variant_option2.textContent = select.value;
          }
          gaEvent('mattress_selected', [select.value, '', '', '', '', ''], false);
        });
      });
      
      function formatToIndianNumberingSystem(number) {
        return Math.round(number)
            .toString() 
            .replace(/\B(?=(\d{3})+(?!\d))/g, ",") 
            .replace(/(\d+),(\d{2})(?!\d)/, "$1,$2");
      }
  
      // Update selected radio button UI
      $(document).on('change', '.dev_npdp_variant_change', function(){
          $(this).parents('.npdp-variant-options').find('.npdp-radio-label').removeClass('selected-radio');
          $(this).parent('.npdp-radio-label').addClass('selected-radio');
          $(this).parents('.dev_parent_to_change_variant_name').find('.v2_selected_variant').text($(this).data('select_value'));
          const element = $(this).parents('.dev_parent_to_change_variant_name').find('.npdp-variant-options');
          const selectedOption = $(this).val();          
          if ($(element).hasClass('npdp-variant-options-name-size')) {
            gaEvent('size_selected', [selectedOption, '', '', '', '', ''], false);
          } else {
            gaEvent('frame_selected', [selectedOption, '', '', '', '', ''], false);
          }
      });
      
      document.querySelectorAll('.npdp-variant-options-name-size .npdp-radio-label').forEach(label => {
        label.addEventListener('click', () => {
          document.querySelectorAll('.npdp-variant-options-name-size .npdp-radio-label').forEach(el => {
            el.classList.remove('selected-radio');
          });

          label.classList.add('selected-radio');

          const dev_selected_variant_option1 = document.getElementById('dev_selected_variant_option1');
          if (dev_selected_variant_option1) {
            dev_selected_variant_option1.textContent = label.textContent.trim();
          }
          
          const selectedSizeInput = label.querySelector('input');
          if (selectedSizeInput) {
            const selectedSize = selectedSizeInput.getAttribute('data-select_value');
            
            updateMattressDropdown(selectedSize);
          }
        });
      });

      document.querySelectorAll('.npdp-variant-options-name-category .npdp-radio-label').forEach(label => {
        label.addEventListener('click', () => {
          document.querySelectorAll('.npdp-variant-options-name-category .npdp-radio-label').forEach(el => {
            el.classList.remove('selected-radio');
          });

          label.classList.add('selected-radio');

          const dev_selected_variant_option1 = document.getElementById('dev_selected_variant_option1');
          if (dev_selected_variant_option1) {
            dev_selected_variant_option1.textContent = label.textContent.trim();
          }
          
          const selectedSizeInput = label.querySelector('input');
          if (selectedSizeInput) {
            const selectedSize = selectedSizeInput.getAttribute('data-select_value');
            
            updateMattressDropdown(selectedSize);
          }
        });
      });
      document.querySelectorAll('.npdp-variant-options-name-category_type .npdp-radio-label').forEach(label => {
        label.addEventListener('click', () => {
          document.querySelectorAll('.npdp-variant-options-name-category_type .npdp-radio-label').forEach(el => {
            el.classList.remove('selected-radio');
          });

          label.classList.add('selected-radio');

          const dev_selected_variant_option2 = document.getElementById('dev_selected_variant_option2');
          if (dev_selected_variant_option2) {
            dev_selected_variant_option2.textContent = label.textContent.trim();
          }
          
          const selectedSizeInput = label.querySelector('input');
          if (selectedSizeInput) {
            const selectedSize = selectedSizeInput.getAttribute('data-select_value');
            
            updateMattressDropdown(selectedSize);
          }
        });
      });
    });
  
    $(document).ready(function() { 
      runBundleScript(window.newPDPFirstProductId);
      // Enable all variant selectors - both radio buttons and dropdowns
      $(document).find('.dev_npdp_variant_change').prop("disabled", false);
      $(document).find('.dev_npdp_variant_change_selector_element').prop("disabled", false);
    });
  
  $(document).ready(function () {
    const popupPincode = localStorage.getItem('popupPincode');
    if (popupPincode) {
      $(document).find(".dev_pincode").val(popupPincode);
      setTimeout(function () {
        $(document).find('.dev_npdp_checkpincode').trigger("click");
      }, 1000); // 1-second delay
    }
   });
  
   const newpslider = document.querySelector('.offer-slider');
   if (newpslider){
   let isDown = false;
   let startX;
   let scrollLeft;
   
   newpslider.addEventListener('mousedown', (e) => {
       isDown = true;
       newpslider.classList.add('active');
       startX = e.pageX - newpslider.offsetLeft;
       scrollLeft = newpslider.scrollLeft;
   });
   
   newpslider.addEventListener('mouseleave', () => {
       isDown = false;
       newpslider.classList.remove('active');
   });
   
   newpslider.addEventListener('mouseup', () => {
       isDown = false;
       newpslider.classList.remove('active');
   });
   
   newpslider.addEventListener('mousemove', (e) => {
       if (!isDown) return;
       e.preventDefault();
       const x = e.pageX - newpslider.offsetLeft;
       const walk = (x - startX) * 2; 
       newpslider.scrollLeft = scrollLeft - walk;
   });
  }
  
  $(document).on('click', '.shop-button-wrapper', function() {
   dataLayer.push({ custom: null }); 
   dataLayer.push({
       event: "video_call_popin",
       custom: {
           param_1: "product_page",  
           param_2: "", 
           param_3: "",	
           param_4: "",
           param_5: "",
           param_6: ""
       }
   });
  
  });
  
  document.addEventListener('DOMContentLoaded', function() {
    new Swipix({
      container: '.custom-swiper-container',
      nextButton: '.custom-right-arrow',
      prevButton: '.custom-left-arrow',
      slidesPerView: {
        default: 4, 
      },
    }).init();
  });
  
  $(document).ready(function() {
    $('.dev_full_screen_icon').on('click', function() {
      if( $('.slick-active .dev_image_full_screen').hasClass('slide-video')){
        window.open($('.slick-active .dev_image_full_screen').attr('href'));
      }else{
        $('.slick-active .dev_image_full_screen').trigger('click');
      }
    });
  
  document.querySelectorAll('.npdp-radio-label').forEach(label => {
      label.addEventListener('click', function() {
        document.getElementById('npdp-main-sns').scrollIntoView({ behavior: 'smooth' });
      });
    });
  });

document.querySelectorAll('.npdp-variant-options-name-frame_type___color .npdp-radio-label').forEach(label => {
  label.addEventListener('click', () => {
    // Remove 'selected-radio' from all labels
    document.querySelectorAll('.npdp-variant-options-name-frame_type___color .npdp-radio-label').forEach(el => {
      el.classList.remove('selected-radio');
    });

    // Add 'selected-radio' to the clicked label
    label.classList.add('selected-radio');

    const dev_selected_variant_option3 = document.getElementById('dev_selected_variant_option3');
    if (dev_selected_variant_option3) {
        dev_selected_variant_option3.textContent = label.textContent.trim();
    }
    
    const input = label.querySelector('input');
    if (input) {
      input.checked = true;
      const changeEvent = new Event('change', { bubbles: true });
      input.dispatchEvent(changeEvent);
    }
  });
});
  
  // Whishlist script
  function setCookie(name, value, minutes) {
    let expires = "";
    if (minutes) {
        let date = new Date();
        date.setTime(date.getTime() + minutes * 60 * 1000);
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + JSON.stringify(value) + expires + "; path=/";
  } 
  
  function getCookie(name) {
    let nameEQ = name + "=";
    let ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i].trim();
      if (c.indexOf(nameEQ) === 0) {
        try {
          return JSON.parse(c.substring(nameEQ.length, c.length));
        } catch (e) {
          console.error("Error parsing cookie:", name, e);
          return null;
        }
      }
    }
    return null;
  }
  
  function deleteCookie(name) {
    document.cookie = name + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
  }
  
  $(document).ready(function () {
    let wishlistSynced = getCookie('wishlist_synced');
  
    if (wishlistSynced && wishlistSynced.productId === window.productDetails.id) {
      $("#pdpwishlist svg circle").css("fill", "#1a2b58");
      $("#pdpwishlist svg path").css("fill", "#FFF");
      deleteCookie('wishlist_synced');
    }
  });
  
  function setWishlistHeartFilled() {
  $('#pdpwishlist svg').css('fill', '#1A2B58');
  $('.add_to_wishlist').removeClass('add_to_wishlist').addClass('remove_from_wishlist');
}

function setWishlistHeartEmpty() {
  $('#pdpwishlist svg').css('fill', '#FFFFFF');
  $('.remove_from_wishlist').removeClass('remove_from_wishlist').addClass('add_to_wishlist');
}

/* ---------- datafeed API call (LeadSquared / WebEngage) ---------- */

/**
 * /lead/datafeed is a LEAD-capture endpoint (feeds LeadSquared + WebEngage), not a
 * wishlist-data endpoint. This payload shape is copied from a call to this same
 * endpoint that is already working elsewhere in your theme (wishlist_login_popup
 * section), so the field names below are confirmed-correct, not a guess.
 *
 * window.userData currently exposes: isLoggedIn (customer id), phone, email.
 * It does NOT expose a name field yet — user_name will be sent as an empty string
 * until that's added to window.userData. If a blank user_name causes lead-creation
 * to fail on your CRM side, that field needs to be added to window.userData by
 * whoever sets that variable (probably a Liquid snippet using {{ customer.name }}).
 */
function buildDatafeedPayload(requestData) {
  const userName = (window.userData && window.userData.name) || '';
  const userEmail = (window.userData && window.userData.email) || '';
  const userPhone = (window.userData && window.userData.phone) || '';

  const productType = requestData.productType || '';
  const productName = (window.productDetails && window.productDetails.titleJson) || '';
  const variantId = requestData.variantId || '';

  const primaryProductCategory = window.getPrimaryProductCategory
    ? window.getPrimaryProductCategory(
        productType,
        productName,
        (window.productDetails && window.productDetails.collectionHandle) || '',
        requestData.productId
      )
    : '';

  return {
    user_name: userName,
    user_email: userEmail,
    phone: userPhone,
    source: 'Wishlist',
    activity_source: 'Wishlist',
    product_type: productType,
    product_name: productName,
    lead_status: 'Tier 1',
    mx_custom_3: productType,
    mx_custom_6: productName,
    mx_custom_9: productName,
    variant_id: variantId,
    mx_Primary_Product_Category: primaryProductCategory,
    mx_mobile_device: getDeviceModel(),
    mx_mobile_os: getOSWithVersion(),
    is_web_engage_event: true,
    web_engage_data: {
      product_category: productType,
      product_subcategory: productName,
      variant_id: variantId
    }
  };
}

function sendToDatafeed(requestData) {
  const myHeaders = new Headers();
  myHeaders.append('Content-Type', 'application/json');

  const raw = JSON.stringify(buildDatafeedPayload(requestData));

  const requestOptions = {
    method: 'POST',
    headers: myHeaders,
    body: raw,
    redirect: 'follow'
  };

  fetch('https://apis.thesleepcompany.in/lead/datafeed', requestOptions)
    .then(response => response.text())
    .then(result => console.log('Datafeed response:', result))
    .catch(error => console.error('Datafeed API Error:', error));
}

/* ---------- On page load: restore heart state from the real wishlist API ---------- */
/*
   The old cookie/localStorage approach only ever reflected "did I just click this
   button", not "is this product actually in my wishlist". The correct fix (matching
   how it's done elsewhere on the site) is to GET the customer's real wishlist and
   check whether this product is in it — that's what stays accurate across refreshes,
   devices, and sessions.
*/
$(document).ready(function () {
  if (!window.userData || !window.userData.isLoggedIn || !window.productDetails) {
    return; // guest / no product context — nothing to check server-side
  }

  const userId = window.userData.isLoggedIn.toString();
  const productId = window.productDetails.id.toString();
  const getUrl = `https://ux6g55bd4a.execute-api.ap-south-1.amazonaws.com/prod/wishlist/${userId}`;
  const apiKey = 'KPwkS7MFb71KXrezuxUYJaf4EnFGvgkK9kgWaf7q';

  fetch(getUrl, {
    method: 'GET',
    headers: { 'x-api-key': apiKey }
  })
    .then(response => response.json())
    .then(data => {
      const isWishlisted = data.wishlist && data.wishlist.some(p => p.productId == productId);
      if (isWishlisted) {
        setWishlistHeartFilled();
      }
    })
    .catch(error => console.error('Wishlist status check failed:', error));
});

$(document).on('click', '.add_to_wishlist', function () {
  const pageVariantId = new URLSearchParams(window.location.search).get('variant') || '';

  if (window.userData && window.userData.isLoggedIn) {
    const apiUrl = `https://ux6g55bd4a.execute-api.ap-south-1.amazonaws.com/prod/wishlist`;
    const apiKey = 'KPwkS7MFb71KXrezuxUYJaf4EnFGvgkK9kgWaf7q';

    const requestData = {
      userId: window.userData.isLoggedIn.toString(),
      productId: window.productDetails.id.toString(),
      productUrl: window.productDetails.handle.toString(),
      productType: window.productDetails.type.toString(),
      productAvailability: window.productDetails.available.toString(),
      productPrice: window.productDetails.price.toString(),
      variantId: pageVariantId,
      action: 'ADD_TO_WISHLIST',
    };

    // Fire the lead/datafeed call alongside the wishlist call
    sendToDatafeed(requestData);

    fetch(apiUrl, {
      method: 'POST',
      headers: {
        'x-api-key': apiKey,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(requestData)
    })
      .then(response => response.json())
      .then(data => {
        if (data.success === true) {
          setWishlistHeartFilled();

          var wishlistNotification = '<div id="prod_wishlisted" class="centered-container" style="z-index: 9;position: fixed;bottom: 10%;left: 50%;transform: translateX(-50%);border-radius: 20px;background-color: #1a2b58;width: 270px;height: 40px;display: flex;color: white;align-items: center;justify-content: center">' +
            '<p>Product is wishlisted!</p>' +
          '</div>';

          $('body').append(wishlistNotification);
          setTimeout(function () {
            $('body #prod_wishlisted').remove();
          }, 2000);
        }
      })
      .catch(error => console.error('Wishlist API Error:', error));

  } else {
    // Not logged in: match the site's existing pattern — stash the pending product
    // id and send the user to log in; the theme's post-login script (see
    // wishlist_login_popup section) re-checks 'wishlist-product' from localStorage
    // and completes the ADD_TO_WISHLIST + datafeed calls after login.
    localStorage.setItem('wishlist-product', window.productDetails.id);
    window.location.href = '/account/login';
  }
});

$(document).on('click', '.remove_from_wishlist', function () {
  const apiUrl = `https://ux6g55bd4a.execute-api.ap-south-1.amazonaws.com/prod/wishlist`;
  const apiKey = 'KPwkS7MFb71KXrezuxUYJaf4EnFGvgkK9kgWaf7q';

  const requestData = {
    userId: window.userData.isLoggedIn.toString(),
    productId: window.productDetails.id.toString(),
    productUrl: window.productDetails.handle.toString(),
    action: 'REMOVE_FROM_WISHLIST'
  };

  fetch(apiUrl, {
    method: 'POST',
    headers: {
      'x-api-key': apiKey,
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(requestData)
  })
    .then(response => response.json())
    .then(data => {
      if (data.success === true) {
        setWishlistHeartEmpty();
      }
    })
    .catch(error => console.error('Error:', error));
});


document.getElementById('dev_click-product_size-open-modal').addEventListener('click', function() {
  const sizeElement = document.getElementById('dev_v2_main_container');
  if (sizeElement) {
    sizeElement.classList.add('open-product-size-modal');
  }
});

document.querySelectorAll('.dev_close-bed-variant-modal').forEach(function(closeButton) {
  closeButton.addEventListener('click', function() {
    const sizeElement = document.getElementById('dev_v2_main_container');
    if (sizeElement) {
      sizeElement.classList.remove('open-product-size-modal');
    }
  });
});


document.getElementById('dev_tclick-mattress-pdp-atc-btn').addEventListener('click', function() {
  //document.getElementById('add-to-cart-button').click();
  const sizeElement = document.getElementById('dev_v2_main_container');
  sizeElement.classList.remove('open-product-size-modal');
  gaEvent('size_confirmed', ['', '', '', '', '', ''], false);
});